// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {randomElementFromArray, randomElementsFromArray} from '../core/Utilities';
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import CoreStyles from '../core/Styles';
import {HeadingMediumText, BodyText, LabelSmallText} from '../core/Type';
import {FixedSpace} from '../core/Spacing';
// Icons
import ContentIcon from '../icons/ContentIcon';

export default class LessonTOC extends React.Component {
    static Variant = {
        InGrid: "inGrid", // Default variant
        Docked: "docked",
    };
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
            },
            dockedContainer: {
                backgroundColor: CoreMetrics.Color.Neutral.OffWhite,
                height: "100%",
            },
            header: {
                paddingTop: CoreMetrics.ElementPadding.XLarge(),
                paddingBottom: CoreMetrics.ElementPadding.Medium(),
            },
            dockedHeader: {
                paddingLeft: CoreMetrics.Grid.HorizontalMargin,
                paddingRight: CoreMetrics.Grid.HorizontalMargin,
            },
            breadcrumb: {
                display: "inline-block",
                color: CoreMetrics.Color.Control.Default,
            },
            lessonTitle: {
                display: "inline-block",
            },
            dockedRow: {
                paddingLeft: CoreMetrics.Grid.HorizontalMargin,
                paddingRight: CoreMetrics.Grid.HorizontalMargin,
            },
        });

        const {variant} = this.props;
        const containerStyles = [
            styles.container,
            (variant === LessonTOC.Variant.Docked) ? styles.dockedContainer : null,
            (variant === LessonTOC.Variant.Docked) ? CoreStyles.hairlineOuterStroke : null,
        ];
        const headerStyles = [
            styles.header,
            CoreStyles.hairlineStrokeBottom,
            (variant === LessonTOC.Variant.Docked) ? styles.dockedHeader : null,
        ];
        const rowStyles = [
            (variant === LessonTOC.Variant.Docked) ? styles.dockedRow : null,
        ];

        const contentItems = randomElementsFromArray(ContentData.Content, 12);

        return (
            <div className={css(containerStyles)}>
                <div className={css(headerStyles)}>
                    <LabelSmallText styles={[styles.breadcrumb]}>{randomElementFromArray(ContentData.Subjects)} • {randomElementFromArray(ContentData.Units)}</LabelSmallText>
                    <FixedSpace variant={FixedSpace.Variant.Vertical} />
                    <HeadingMediumText styles={[styles.lessonTitle]}>{randomElementFromArray(ContentData.Lessons)}</HeadingMediumText>
                </div>
                <div>
                    {contentItems.map((name, index) => {
                        const selected = (index === 2);
                        return <ContentItemRow
                            key={index}
                            styles={rowStyles}
                            title={name}
                            selected={selected}
                        />;
                    })}
                </div>
            </div>
        );
    }
}
LessonTOC.defaultProps = {
    variant: LessonTOC.Variant.InGrid,
};

class ContentItemRow extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                paddingTop: CoreMetrics.ElementPadding.Small(),
                paddingBottom: CoreMetrics.ElementPadding.Small(),
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                overflow: "hidden",
            },
            title: {
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: "100%",
            },
            selectedTitle: {
                color: CoreMetrics.Color.Control.Default,
            },
        });

        const containerStyles = [styles.container, ...this.props.styles];
        const labelStyles = [styles.title];
        if (this.props.selected) {
            containerStyles.push(CoreStyles.hairlineStrokeTopAndBottom);
            labelStyles.push(styles.selectedTitle);
        }
        return (
            <div className={css(containerStyles)}>
                <ContentIcon />
                <FixedSpace />
                <BodyText styles={labelStyles}>{this.props.title}</BodyText>
            </div>
        );
    }
}
ContentItemRow.defaultProps = {
    styles: [],
};



// WEBPACK FOOTER //
// ./src/modules/LessonTOC.jsx